import axios from "axios";
import { PROTOCOL, URL } from "../../utils/constants";
import authHeader from "../auth-header";

const API_URL = `${PROTOCOL}://${URL}/okapi/mibui`;

export const getUserActionLogs = async ({
  page = 1,
  limit = 50,
  startDate,
  endDate,
  actionType,
  username,
}) => {
  try {
    const response = await axios.get(`${API_URL}/audit/logs`, {
      params: {
        page,
        limit,
        startDate,
        endDate,
        actionType,
        username,
      },
      headers: authHeader()
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching user action logs:", error);
    throw error;
  }
};

export const exportUserActionLogs = async ({
  startDate,
  endDate,
  actionType,
  username,
}) => {
  try {
    const response = await axios.get(`${API_URL}/audit/export`, {
      params: {
        startDate,
        endDate,
        actionType,
        username,
      },
      headers: authHeader(),
      responseType: "blob", // Important for file downloads
    });

    // Create a URL for the blob and trigger a download
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    const now = new Date();
    const datePart = [
      now.getFullYear(),
      String(now.getMonth() + 1).padStart(2, "0"),
      String(now.getDate()).padStart(2, "0"),
    ].join("-");
    const timePart = [
      String(now.getHours()).padStart(2, "0"),
      String(now.getMinutes()).padStart(2, "0"),
      String(now.getSeconds()).padStart(2, "0"),
    ].join(".");
    const timestamp = `${datePart}-${timePart}`;
    link.setAttribute("download", `user_action_logs_${timestamp}.csv`); // Set the file name
    document.body.appendChild(link);
    link.click();
    window.URL.revokeObjectURL(url); // Clean up the URL object
    document.body.removeChild(link);
  } catch (error) {
    console.error("Error exporting user action logs:", error);
    throw error;
  }

};

export const getDagLogs = async ({
  page = 1,
  limit = 50,
  startDate,
  endDate,
  status,
}) => {
  try {
    const response = await axios.get(`${API_URL}/dag-logs`, {
      params: {
        page,
        limit,
        startDate,
        endDate,
        status,
      },
      headers: authHeader(),
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching DAG logs:", error);
    throw error;
  }
};

export const exportDagLogsCSV = async ({ startDate, endDate, status }) => {
  try {
    const response = await axios.get(`${API_URL}/dag-logs/export/csv`, {
      params: {
        startDate,
        endDate,
        status,
      },
      headers: authHeader(),
      responseType: "blob",
    });

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    const now = new Date();
    const datePart = [
      now.getFullYear(),
      String(now.getMonth() + 1).padStart(2, "0"),
      String(now.getDate()).padStart(2, "0"),
    ].join("-");
    const timePart = [
      String(now.getHours()).padStart(2, "0"),
      String(now.getMinutes()).padStart(2, "0"),
      String(now.getSeconds()).padStart(2, "0"),
    ].join(".");
    const timestamp = `${datePart}-${timePart}`;
    link.setAttribute("download", `dag_logs_${timestamp}.csv`);
    document.body.appendChild(link);
    link.click();
    window.URL.revokeObjectURL(url);
    document.body.removeChild(link);
  } catch (error) {
    console.error("Error exporting DAG logs:", error);
    throw error;
  }
};
